<template>
    <div class="forum-home-categories">
        <Loader v-if="loading" />
        <ul v-else>
            <li v-for="category in categories">
                <ForumCategoryPreview :category="category" />
            </li>
        </ul>
    </div>
</template>

<script>
    import ForumUtils           from '../../utils/forum';
    import ForumCategoryPreview from '../reusable/forum/category-preview';
    import Loader               from '../reusable/forum/loader';

    export default {
        components: {
            ForumCategoryPreview,
            Loader,
        },

        data() {
            return {
                loading: false,
            };
        },

        async created() {
            this.loading = true;
            await this.$store.dispatch('ensureForumCategories');
            this.loading = false;
        },

        computed: {
            categories() {
                const cats = this.$store.getters.forumCategories;
                return ForumUtils.sortCategories(cats);
            },
        },
    }
</script>

<style lang="scss" scoped>
    ul {
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            margin-top: 60px;

            &:first-of-type {
                margin-top: 40px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ForumHomeCategories.vue?744a9abd